/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { styled } from 'fierry/react';

import BorderGroup from 'solis/react/board/hex/border.group';

import { pulse, glow } from 'solis/react/board/highlights/animation';


const Tick = styled.line`
  ${glow}
  ${pulse}

  stroke-linecap: round;

  stroke: var(--accent-11);

  stroke-width: ${({ hexGeometry }) => hexGeometry.getExternalBorderWidth()};
`;


const getLine = ({ hexGeometry }) =>
{
  const offset = hexGeometry.getExternalWidth(0.075);
  const length = hexGeometry.getExternalSize(0.075);

  return { x1: offset, y1: 0, x2: offset + length, y2: 0 };
};


const Line = (props) =>
{
  return <Tick {...props} {...getLine(props)} />;
};


export default (props) =>
{
  return <BorderGroup {...props} Component = {Line} />;
};
